import React from 'react'
import type { Timespan as TimespanType } from '@app-types/entity_types'
import FormattedTime from '@components/FormattedTime'
import { sanitize, markupAndSanitize } from '@utils/sanitize'

type TimespanProps = {
  data: TimespanType
}

const Timespan: React.FC<TimespanProps> = props => {
  const { data } = props

  const getDescriptionContent = () => {
    const description = data.description
    if (description && description !== '') {
      return (
        <div
          className="timeline-item-detail__description block p-x marked-up"
          dangerouslySetInnerHTML={{ __html: markupAndSanitize(description) }}
        />
      )
    }
    return null
  }

  const description = getDescriptionContent()
  return (
    <li className="timeline-item timeline-item--viewer">
      <div className="timeline-item__connector-line"></div>
      <div className="timeline-item__dot">
        <div className="dot__graphic"></div>
      </div>
      <div className="timeline-item__content-wrapper">
        <div className="timeline-item-detail timeline-item__content">
          <div className="timeline-item-detail__content p-t p-b">
            <div className="timeline-item-detail__meta p-x">
              <div className="timeline-item-detail__time">
                Period: <FormattedTime dateTime={data.start_date} /> to <FormattedTime dateTime={data.end_date} />
              </div>
              <h2 className="timeline-item-detail__title">{sanitize(data.title)}</h2>
            </div>
            {description}
          </div>
        </div>
      </div>
    </li>
  )
}

export default React.memo(Timespan)
